import React, { useEffect, useState } from 'react'
import Modal from 'react-responsive-modal'
import { useDispatch, useSelector } from 'react-redux'
import styles from './styles.module.css'
import { useFormik } from 'formik'
import { Input } from '../../components/ModalInputs'
import * as Yup from 'yup'
import ModalFooter from '../../components/ModalFooter/ModalFooter'
import Table from '../../components/Table'
import { BiTrash } from 'react-icons/bi'
import ModalSpec from './Spec/ModalSpec'
import { IoIosAdd } from 'react-icons/io'
import Button from '../../components/Button'
import { createOrder, deleteOrderSpec, getSpecFields, getSpecTypesList, updateOrder } from '../../actions/orders'
import Confirmation from '../../components/Confirmation/Confirmation'

const validationSchema = Yup.object({
  name: Yup.string().required('обязательное поле').max(30, 'Должно быть не более 30 символов'),

})



export default function ModalComponent({ data, closeModal, height, addMode }) {

  const dispatch = useDispatch()

  const { ordersList, loading, specFields, specs } = useSelector(state => state.orders)

  const [selectedSpec, setSelectedSpec] = useState(null)
  const [confirmation, setConfirmation] = useState(false);

  useEffect(() => {
    dispatch(getSpecTypesList())
  }, [])

  // useEffect(() => {
  //   selectedSpec?.idorderspectype && dispatch(getSpecFields(selectedSpec?.idorderspectype))
  // }, [selectedSpec])

  const handleCreate = (values) => {
    dispatch(createOrder(values))
    closeModal()
    resetForm()

  }

  const handleUpdate = (values) => {
    dispatch(updateOrder(values))
    closeModal()
    resetForm()

  }

  const acceptConfirmation = () => {
    // closeModal();
    dispatch(deleteOrderSpec(values.idorder, confirmation.id));
    setConfirmation(false);
  };
  const rejectConfirmation = () => {
    setConfirmation(false);
  };

  const {
    values,
    errors,
    touched,
    submitCount,
    handleChange,
    handleSubmit,
    resetForm,
  } = useFormik({
    initialValues: addMode ? {} : data,
    enableReinitialize: true,
    validateOnChange: true,
    // validationSchema: validationSchema,
    onSubmit: addMode ? handleCreate : handleUpdate
  })

  const error = (fieldName) => (touched[fieldName] || submitCount) && errors[fieldName]

  const openModalOrder = (data) => () => {
    setSelectedSpec(data || {})
  }

  const closeModalOrder = () => {
    setSelectedSpec(null)
    resetForm()
  }

  const renderLi = (data, i) => {
    const { name, idorderspec, spec_type } = data
    return (
      <tr>
        <td onClick={openModalOrder(data)}>{i + 1}</td>
        <td onClick={openModalOrder(data)}>{spec_type}</td>
        <td onClick={openModalOrder(data)}>{name}</td>
        <td><i className={styles.trash} onClick={() => setConfirmation({ id: idorderspec, name })}><BiTrash /></i></td>
      </tr>
    )
  }

  return (
    <Modal
      open={!!data}
      onClose={() => false}
      showCloseIcon={false}
      height={height}
      center
      classNames={{
        // overlay: styles.overlay,
        modal: styles.custom
      }}
    >
      {confirmation && (
        <Confirmation
          top="30px"
          left="40px"
          title={`Вы уверены, что хотите удалить ${confirmation.name}?`}
          acceptConfirmation={() => acceptConfirmation(confirmation?.name)}
          rejectConfirmation={rejectConfirmation}
        />
      )}
      <>
        {selectedSpec &&
          <ModalSpec
            closeModal={closeModalOrder}
            data={selectedSpec}
            height={'430px'}
            // addMode={(!selectedSpec?.name && selectedSpec !== null)}
            addMode={selectedSpec == 'add'}
            idorder={values.idorder}
          />
        }
        <div className={styles.modalLocal}  >
          <div className={styles.tabWrapper} >

            <div className={styles.inputsRow}>
              <Input
                type='date'
                label='Дата приказа'
                name='orderdate'
                value={values.orderdate}
                onChange={handleChange}
                style={{ justifyContent: 'flex-start !important' }}
              />
            </div>

            <div className={styles.inputsRow}>
              <Input
                label='Номер приказа'
                name='ordernum'
                value={values.ordernum}
                error={error('ordernum')}
                onChange={handleChange}
                style={{ width: '600px' }}
              />
            </div>
            <div className={styles.inputsRow}>
              <Input
                label='Название приказа'
                name='ordertitle'
                value={values.ordertitle}
                error={error('ordertitle')}
                onChange={handleChange}
                style={{ width: '600px' }}
              />
            </div>
            {!addMode &&
              <>
                <p style={{ color: '#778AAF', fontSize: '13px', marginLeft: '13px' }}>Спецификации приказа</p>
                <div style={{ margin: '2rem 0', backgroundColor: 'white' }}>
                  <Table>
                    <thead>
                      <tr>
                        <th>№</th>
                        <th>Тип</th>
                        <th>Название</th>
                      </tr>
                    </thead>
                    <tbody>
                      {specs?.data?.map(renderLi)}
                    </tbody>
                  </Table>
                </div>
                <div style={{ display: 'flex', flexDirection: "row" }}>
                  <Button
                    style={{ padding: '.5rem 1.5rem', margin: '12px' }}
                    onClick={openModalOrder('add')}
                  >
                    <IoIosAdd size={30} />
                    Добавить
                  </Button>
                </div>
              </>
            }
          </div>
        </div>

        <ModalFooter handleSubmit={handleSubmit} closeModal={closeModal} />
      </>
    </Modal>

  )
}
